<mat-select
  [id]="matSelectId"
  [formControl]="control"
  class="form-control"
  multiple
>
  @if (displayPlaceholder && placeholder != null) {
  <mat-option [value]="ignoreValue" class="mat-primary">
    {{ placeholder }}
  </mat-option>
  } @for (option of options; track option) {
  <mat-option [value]="option.value" class="mat-primary">
    {{ option.label }}
  </mat-option>
  }
</mat-select>
